import { z } from 'zod';

import { isString, isEmpty } from '../../../utils/common.util';

export const RequireBlockSchema = z.boolean();

export type RequireBlock = z.infer<typeof RequireBlockSchema>;

type IsRequired = (value: unknown, block: RequireBlock) => boolean;
export const isRequired: IsRequired = (value, block) => {
  if (isString(value)) {
    if (block) {
      return isEmpty(value) === false;
    }

    return true;
  }

  return block ? value !== undefined : true;
};
